var styleDataHash = "6a16e68a";
const injectCss = () => {
  var css = `.uFWWX{align-items:center;box-sizing:border-box;color:var(--ricos-settings-text-color,#000);display:flex;font-size:14px;height:40px;width:100%}[dir] .uFWWX{background-color:#fff}[dir=ltr] .uFWWX,[dir=rtl] .uFWWX{padding-left:20px;padding-right:20px}.uFWWX *,.uFWWX :after,.uFWWX :before{box-sizing:inherit}.uFWWX input{box-sizing:border-box}.uFWWX>*{flex:1}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
};
injectCss();
var list_item_toggle_default = {
  "container": "uFWWX"
};
export {
  list_item_toggle_default as default,
  injectCss
};
//# sourceMappingURL=list-item-toggle-scss.js.map
